"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var globalTypes_1 = require("../../../gen-src/queries/globalTypes");
function makeDC3ColumnFactoryParamsFromVizPortalParams(vizPortalColumnParams) {
    var orderBy = orderClausesToOrderBy(vizPortalColumnParams.currentSort);
    // VizPortal uses lowercase order params, so as we send the sort field to the VizPortal infrastructure,
    // make it lowercase to match the order fields as VizPortal expects to find them.
    var updateSortOrder = function (field) { return vizPortalColumnParams.changeSort(field.toLowerCase()); };
    if (orderBy) {
        return { orderBy: orderBy, updateSortOrder: updateSortOrder, actionCellWrapper: vizPortalColumnParams.actionCellWrapper };
    }
    else {
        return { actionCellWrapper: vizPortalColumnParams.actionCellWrapper };
    }
}
exports.makeDC3ColumnFactoryParamsFromVizPortalParams = makeDC3ColumnFactoryParamsFromVizPortalParams;
/**
 * Converts an OrderClauses array (from VizPortal) to an OrderBy (for DC3).
 * We do this conversion in one layer where we need compatibility with VizPortal's types.
 */
function orderClausesToOrderBy(orderClauses) {
    var orderClause = orderClauses && orderClauses[0];
    if (!orderClause) {
        return undefined;
    }
    return {
        field: orderClause.field,
        direction: orderClause.ascending ? globalTypes_1.OrderDirection.ASC : globalTypes_1.OrderDirection.DESC
    };
}
exports.orderClausesToOrderBy = orderClausesToOrderBy;
//# sourceMappingURL=makeColumnFactoryParams.js.map